export default {"src":"/pro/_next/static/media/vovrtx.a1067700.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};